import { Link } from 'react-router-dom';
import { submitForm } from '@/utils/formHandler';

const productLinks = [
  { label: 'Altyapı Lightbox', href: '/urunler/altyapi-lightbox' },
  { label: 'Standart Lightbox', href: '/urunler/standart-lightbox' },
  { label: 'Lightbox Reklam Giydirme', href: '/urunler/reklam-giydirme' },
  { label: 'Dolak Lightbox', href: '/urunler/dolak-lightbox' },
  { label: 'Kutu Harf Lightbox', href: '/urunler/kutu-harf' },
  { label: 'Dış Mekan Lightbox', href: '/urunler/dis-mekan-lightbox' },
];

const projectLinks = [
  { label: 'Tüm Projeler', href: '/referanslar' },
  { label: 'Mağaza Cephesi', href: '/referanslar' },
  { label: 'Dış Mekan', href: '/referanslar' },
  { label: 'Kurumsal', href: '/referanslar' },
  { label: 'Restoran & Kafe', href: '/referanslar' },
];

const blogLinks = [
  { label: 'Lightbox Nedir?', href: '/blog/lightbox-nedir-kapsamli-rehber' },
  { label: 'Lightbox Fiyatları 2026', href: '/blog/lightbox-fiyatlari-2026' },
  { label: 'Kutu Harf mi Lightbox mı?', href: '/blog/kutu-harf-mi-lightbox-mi' },
  { label: 'Dış Mekan Tabela Rehberi', href: '/blog/dis-mekan-isikli-tabela-secim-rehberi' },
];

export default function Footer() {
  const handleNewsletter = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const data = Object.fromEntries(fd.entries()) as Record<string, string>;
    const result = await submitForm(data, 'newsletter');
    if (result.success) {
      form.reset();
      const btn = form.querySelector('button');
      if (btn) { btn.textContent = 'Abone Olundu!'; }
    }
  };

  return (
    <footer className="bg-[#111111]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <h2 className="sr-only">Hızlı Bağlantılar</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center mb-4 cursor-pointer">
              <img
                src="/images/logo.webp"
                alt="İzmir Lightbox Logo"
                width="148"
                height="48"
                className="h-12 w-auto object-contain"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              İzmir'in güvenilir lightbox üreticisi. Tasarımdan uygulamaya tüm süreçlerde yanınızdayız.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-instagram-line', href: '#', label: 'Instagram' },
                { icon: 'ri-facebook-line', href: '#', label: 'Facebook' },
                { icon: 'ri-youtube-line', href: '#', label: 'YouTube' },
                { icon: 'ri-linkedin-line', href: '#', label: 'LinkedIn' },
              ].map((s) => (
                <a key={s.icon} href={s.href} aria-label={s.label} className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-red-600 rounded-full transition-colors cursor-pointer">
                  <i className={`${s.icon} text-white text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Projelerimiz + Blog */}
          <div>
            <h3 className="text-white font-bold text-sm uppercase tracking-widest mb-5 pb-2 border-b border-red-600/40">Projelerimiz</h3>
            <ul className="space-y-3 mb-6">
              {projectLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-gray-400 hover:text-red-500 text-sm transition-colors cursor-pointer flex items-center gap-2">
                    <i className="ri-arrow-right-s-line text-red-600/60"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h3 className="text-white font-bold text-sm uppercase tracking-widest mb-4 pb-2 border-b border-red-600/40">Blog</h3>
            <ul className="space-y-3">
              {blogLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-gray-400 hover:text-red-500 text-sm transition-colors cursor-pointer flex items-center gap-2">
                    <i className="ri-arrow-right-s-line text-red-600/60"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-bold text-sm uppercase tracking-widest mb-5 pb-2 border-b border-red-600/40">Ürünlerimiz</h3>
            <ul className="space-y-3">
              {productLinks.map((item) => (
                <li key={item.label}>
                  <Link to={item.href} className="text-gray-400 hover:text-red-500 text-sm transition-colors cursor-pointer flex items-center gap-2">
                    <i className="ri-arrow-right-s-line text-red-600/60"></i>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact + Newsletter */}
          <div>
            <h3 className="text-white font-bold text-sm uppercase tracking-widest mb-5 pb-2 border-b border-red-600/40">Bize Ulaşın</h3>
            <ul className="space-y-4 mb-6">
              {[
                { icon: 'ri-phone-line', text: '+90 (536) 277 17 09' },
                { icon: 'ri-whatsapp-line', text: '+90 (536) 277 17 09' },
                { icon: 'ri-mail-line', text: 'atatente@hotmail.com' },
                { icon: 'ri-map-pin-line', text: 'Yeşillik Cad. 5757 Sok. No:22/C Karabağlar / İzmir' },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-red-500 text-sm`}></i>
                  </div>
                  <span className="text-gray-400 text-sm">{item.text}</span>
                </li>
              ))}
            </ul>
            <p className="text-gray-400 text-xs mb-3">E-bültenimize abone olun:</p>
            <form onSubmit={handleNewsletter} className="flex gap-2">
              <input type="email" name="email" required placeholder="E-posta adresiniz"
                className="flex-1 bg-white/10 border border-white/20 text-white placeholder-gray-500 text-xs px-3 py-2.5 rounded-lg focus:outline-none focus:border-red-500 transition-colors" />
              <button type="submit" className="bg-red-600 hover:bg-red-700 text-white text-xs font-bold px-4 py-2.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                Abone Ol
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-300 text-xs">© {new Date().getFullYear()} İzmir Lightbox. Tüm hakları saklıdır.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-gray-400 hover:text-white text-xs cursor-pointer">Gizlilik Politikası</a>
            <a href="#" className="text-gray-400 hover:text-white text-xs cursor-pointer">Kullanım Koşulları</a>
            <span className="text-gray-400 text-xs flex items-center gap-1">
              <i className="ri-map-pin-2-line text-red-500"></i>
              Made in Turkey
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
